import { defineMessages } from 'react-intl';

export default defineMessages({
  editTitle: {
    description: 'UserManagementModal edit mode title',
    defaultMessage: 'Edit User: {name}',
    id: 'KOrlqP',
  },
  createTitle: {
    description: 'UserManagementModal create mode title',
    defaultMessage: 'Create New User',
    id: 'oZHtZQ',
  },
  information: {
    description: 'UserManagementModal Information tab name',
    defaultMessage: 'Information',
    id: 'wF3gDl',
  },
  permissions: {
    description: 'UserManagementModal Permissions tab name',
    defaultMessage: 'Permissions',
    id: 'Jzb32M',
  },
  restrictions: {
    description: 'UserManagementModal Restrictions tab name',
    defaultMessage: 'Restrictions',
    id: '6qWJe7',
  },
  activity: {
    description: 'UserManagementModal Activity tab name',
    defaultMessage: 'Activity',
    id: 'zjP7Vc',
  },
  cancel: {
    description: 'UserManagementModal Cancel button',
    defaultMessage: 'Cancel',
    id: 'i5SmBZ',
  },
  save: {
    description: 'UserManagementModal Save button',
    defaultMessage: 'Save',
    id: 'eSAvOp',
  },
  onSaveSuccess: {
    description: 'Success message indicating a new user was successfully saved/created',
    defaultMessage: 'New user added!',
    id: 'PbQop9',
  },
  onSaveError: {
    description: 'Error message indicating a new user was not saved/created',
    defaultMessage: 'Error creating new user. Please try again.',
    id: 'K/Bksr',
  },
  onUpdateSuccess: {
    description: 'Success message indicating an existing user was successfully updated',
    defaultMessage: 'User updated!',
    id: 'yOg4z1',
  },
  onUpdateError: {
    description: 'Error message indicating an existing user was not updated',
    defaultMessage: 'Error updating user. Please try again.',
    id: 'mk5egc',
  },
  emailInvalid: {
    description: 'Error message about provided email',
    defaultMessage: 'Please enter a valid email',
    id: 'f4zXO4',
  },
  usernameEmptySpaces: {
    description: 'Error message about provided username',
    defaultMessage: 'Username cannot contain spaces',
    id: 'rhq/YO',
  },
  passwordsDoNotMatch: {
    description: 'Error message about provided passwords',
    defaultMessage: 'Passwords do not match',
    id: '+ijfmf',
  },
  passwordTooShort: {
    description: 'Error message about provided passwords',
    defaultMessage: 'Password must be at least 7 characters',
    id: '2sx7Pn',
  },
  nameCannotBeEmpty: {
    description: 'Error message about provided name',
    defaultMessage: 'Name canot be empty',
    id: 'U+hPKQ',
  },
});
